export const REPORT_ISSUE_REQUEST = 'REPORT_ISSUE_REQUEST';
export const REPORT_ISSUE_SUCCESS = 'REPORT_ISSUE_SUCCESS';
export const REPORT_ISSUE_FAILURE = 'REPORT_ISSUE_FAILURE';
export const REPORT_ISSUE_RESET = 'REPORT_ISSUE_RESET';
